export default "__VITE_ASSET__C$abveTW__"